export const Chip = ({ label, content }) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center gap-2">
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: "106px",
          height: "54px",
          borderRadius: "32px",
          backgroundColor: "#008CFF",
          color: "#fff",
        }}
      >
        <label
          className="text-body-b2"
          style={{ fontSize: "24px", fontWeight: "500" }}
        >
          {content}
        </label>
      </div>

      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          color: "#fff",
          marginTop: "12px",
        }}
      >
        <label className="text-body-b2" style={{ textAlign: "center" }}>
          {label}
        </label>
      </div>
    </div>
  );
};
